'use strict';
(function($){
	/*
	 * Vetology.UserProfileManager widget
	 *
	 * @description Handles the user profile
	 *
	 * @options See description for each option
	 *
	 * @method See description above each method
	 */
	$.widget(
		'Vetology.UserProfileManager',
		{
			"options": {
			},
			/*
			 * Vetology.UserProfileManager._init
			 *
			 * @description	Initializes the Vetology.UserProfileManager
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				const _self = this;
				_self._enableHandlers();
                $('form.user-profile-form input.username_email').popover();
			},
			/*
			 * Vetology.UserProfileManager._enableHandlers
			 *
			 * @description	Initializes the event handlers
			 *
			 * @return NULL
			 *
			 */
			"_enableHandlers": function(){
				var _self = this;
				$("body").on("click", ".activateLicense", function(e){
                    e.preventDefault();
                    e.stopImmediatePropagation();
					_self._activateLicense();
				});
				$("body").on("click", ".activateLicenseFix", function(e){
                    e.preventDefault();
                    e.stopImmediatePropagation();
					_self._activateLicenseFix();
				});
                $("body").on("click", ".make_license_primary", function(e){
                    var el = $(this);
                    _self._swapActiveLicense(el.data("id"));
                });

                _self._onClickSave = _self._onClickSave.bind(_self);
                document.querySelectorAll('form.user-profile-form button[data-url="/user/account"]').forEach(elem => {
                    elem.addEventListener('click', _self._onClickSave, true);
                });

                const names = document.querySelectorAll('input[name="first_name"], input[name="last_name"]');
                _self._onNamesChanged = _self._onNamesChanged.bind(_self);
                names.forEach(elem => {
                   elem.addEventListener('input', _self._onNamesChanged);
                });

				_self.onFontSizerChange = _self.onFontSizerChange.bind(_self);
				const fontSizer = document.querySelector('select.fontSizer');
				if (fontSizer) {
					fontSizer.addEventListener('change', _self.onFontSizerChange);
				}
			},

			onFontSizerChange: function(event) {
				const fontSizer = event.target;
				let val = parseInt(fontSizer.value, 0);
				val = val > 5 || val < 0 ? 0 : val;
				let userSettings = document.querySelector('#user_settings');
				if (userSettings) {
					userSettings.remove();
				}
				userSettings = document.createElement('style');
				userSettings.id = 'user_settings';
				userSettings.textContent = "* { font-size: calc(100% * 1.0" + val + "); }";
				document.head.appendChild(userSettings);
			},

			_validateFirstLastNames: function() {
                const names = document.querySelectorAll('form.user-profile-form input[name="first_name"], input[name="last_name"]');
                let valid = true;
                names.forEach(elem => {
                    if (!elem.checkValidity()) {
                        elem.setCustomValidity("Allowed Characters are alpha, dash, quote, space, period, comma, and diacritic characters");
                        elem.reportValidity();
                        valid = false;
                    }
                });
                return valid;
            },

            _onClickSave: function(event) {
                const _self = this;
                if (!_self._validateFirstLastNames()) {
                    event.stopImmediatePropagation();
                }
            },

            _onNamesChanged: function(event) {
                event.target.setCustomValidity("");
            },

			/*
			 * Vetology.VetologyAdmin._activateLicense
			 *
			 * @description	Gets a short link for the user
			 *
			 * @return NULL
			 *
			 */
			_activateLicense: function(el){
				var o = this;
				var license_id = $('[name="license_id"]').val().trim();
				var data = {license_id: license_id};
				if(data.license_id.length === 0){
					$("body").Vetology("vetologyShowDialog", "Error:", "Please enter a license id before trying to activate", "error");
					return;
				}
				$("body").Vetology("doRequest", "POST", data, '/user/account/activate-license', function(data){
					if(data.error){
						$("body").Vetology("vetologyShowDialog", "Error:", data.message, "error");
					} else {
						$("body").Vetology("vetologyShowDialog", "Success:", 'I have activated your license and is ready for usage to find out how to start using your license please go <a href="/tutorial/vetology-ai" target="_blank">here</a>', "success");
					}
				}, 'JSON', true, "Please wait while I activate your license", "Please wait while I activate your license");
			},
			/*
			 * Vetology.VetologyAdmin._activateLicenseFix
			 *
			 * @description	Gets a short link for the user
			 *
			 * @return NULL
			 *
			 */
			_activateLicenseFix: function(el){
				var o = this;
				var license_id = $('[name="license_id_fix"]').val().trim();
				var data = {license_id: license_id,fix:true};
				if(data.license_id.length === 0){
					$("body").Vetology("vetologyShowDialog", "Error:", "Please enter a license id before trying to fix it", "error");
					return;
				}
				$("body").Vetology("doRequest", "POST", data, '/user/account/activate-license', function(data){
					if(data.error){
						$("body").Vetology("vetologyShowDialog", "Error:", data.message, "error");
					} else {
						$("body").Vetology("vetologyShowDialog", "Success:", 'Please wait while we redirect you to Paypal for payment', "success");
						$("body").append(data.encrypted);
						$(".on_purchasing").submit();
					}
				}, 'JSON', true, "Please wait while I create your payment order", "Please wait while I create your payment order");
			},
            _swapActiveLicense: function(license){
                var o = this;
                $("body").Vetology("vetologyLoadStart");
                $.ajax(
                    {
                        type: 'GET',
                        url: '/license/details?primary=' + license,
                        dataType: 'JSON',
                        success: function(data){
                            var licensesTable  =document.getElementById("licenses_info");
                            licensesTable.innerHTML=data.html;
                            $("body").Vetology("vetologyLoadEnd");
                        }
                    }
                );
            },
		}
	);
})(jQuery);
